const btnTreeNode = {
  text: 'Recortar',
  cancel: 'Cancelar'
};

export default btnTreeNode;
